import classNames from 'classnames';
import React from 'react';

import staticURL from 'lib/staticURL';

interface InviteAvatarProps {
  index: number;
  isGold: boolean;
  showGoldStatus: boolean;
}

function InviteAvatar(props: InviteAvatarProps): JSX.Element {
  const suffix = props.isGold ? '_gold' : '';
  return (
    <span>
      <img
        src={staticURL(`/static/img/benchling-gold/avatar_${props.index + 1}${suffix}.png`)}
        className="u-spacing-right u-spacing-bottom"
      />
      {props.showGoldStatus && (
        <span className="u-position-relative">
          <span className={classNames('invitePage-speechBubble', {gold: props.isGold})}>Gold Status!</span>
        </span>
      )}
    </span>
  );
}

interface InviteAvatarsProps {
  numReferralsAccepted: number;
}

export function AcademicInviteAvatars(props: InviteAvatarsProps): JSX.Element {
  return (
    <div>
      {[0, 1, 2, 3, 4].map((i) => (
        <InviteAvatar key={i} index={i} isGold={i < props.numReferralsAccepted} showGoldStatus={i === 4} />
      ))}
    </div>
  );
}
